<script lang="ts">
  export let size: number = 22;
</script>

<svg width={size} height={size} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12.4508 19.0758C12.1391 19.1858 11.6258 19.1858 11.3141 19.0758C8.65576 18.1683 2.71576 14.3825 2.71576 7.96584C2.71576 5.13334 4.99826 2.84167 7.81243 2.84167C9.48076 2.84167 10.9566 3.64834 11.8824 4.89501C12.8083 3.64834 14.2933 2.84167 15.9524 2.84167C18.7666 2.84167 21.0491 5.13334 21.0491 7.96584C21.0491 14.3825 15.1091 18.1683 12.4508 19.0758Z"
    class={$$props.class || "stroke-garden-grey-600"} 
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
